<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    :width="size"
    :height="size"
    role="img"
    :aria-label="`Stopwatch showing ${time}`"
  >
    <rect width="200" height="200" rx="12" fill="#e6e6e6" />
    <g fill="#1c1c1c">
      <rect x="86" y="12" width="28" height="13" rx="3" />
      <rect x="94" y="23" width="12" height="18" />
      <rect
        x="30"
        y="46"
        width="26"
        height="13"
        rx="3"
        transform="rotate(-45 43 52.5)"
      />
      <rect
        x="144"
        y="46"
        width="26"
        height="13"
        rx="3"
        transform="rotate(45 157 52.5)"
      />
      <circle cx="100" cy="114" r="72" />
    </g>
    <circle
      cx="100"
      cy="114"
      r="64"
      fill="none"
      stroke="#4a4a4a"
      stroke-width="2"
    />
    <circle cx="100" cy="114" r="58" fill="#262626" />
    <rect
      x="44"
      y="94"
      width="112"
      height="42"
      rx="7"
      fill="#f4f4f4"
      stroke="#0d0d0d"
      stroke-width="3"
    />
    <text
      x="100"
      y="126"
      text-anchor="middle"
      font-family="'Courier New', monospace"
      font-weight="700"
      :font-size="fontSize"
      letter-spacing="1"
      fill="#dcdcdc"
    >
      {{ ghost }}
    </text>
    <text
      x="100"
      y="126"
      text-anchor="middle"
      font-family="'Courier New', monospace"
      font-weight="700"
      :font-size="fontSize"
      letter-spacing="1"
      fill="#161616"
    >
      {{ time }}
    </text>
    <circle cx="147" cy="102" r="2" fill="#555" />
  </svg>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      default: '00:00'
    },
    size: {
      type: Number,
      default: 100
    }
  },

  computed: {
    ghost() {
      return this.time.replace(/\d/g, '8');
    },

    // Shrink the digits when the time needs more than "MM:SS" to fit the display
    fontSize() {
      return this.time.length > 5 ? 24 : 32;
    }
  }
};
</script>
